<div class="banner"
     *ngFor="let banner of banners">
    <span (click)="openBanner(banner)">The bus is running late than scheduled time for {{banner.routeName}}. Check
        latest ETA for better estimates</span>
    <img (click)="closeBanner(banner.routeId)"
         src="assets/svg/cross.svg"
         alt="close">
</div>
